import template from './assetCommitmentSchedules.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assetCommitmentSchedules: '<',
    companies: '<',
    lenders: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdUtil, helperService, assetFinanceService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableProductTypes = [];
      ctrl.availableTermInMonths = [];
      ctrl.activeTab = 0;
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.assetCommitmentSchedules = ctrl.assetCommitmentSchedules || [];
        ctrl.companies = ctrl.companies || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: true
        });
        ctrl.isReady = true;
      };

      ctrl.assetCommitmentScheduleAdd = () => {
        ctrl.assetCommitmentSchedules = assetFinanceService.assetCommitmentScheduleAdd(
          ctrl.assetCommitmentSchedules
        );
        ctrl.saveAssetCommitmentSchedules();
      };

      ctrl.assetCommitmentAdd = (idx) => {
        ctrl.assetCommitmentSchedules[
          idx
        ].assetCommitments = assetFinanceService.assetCommitmentAdd(
          ctrl.assetCommitmentSchedules[idx]?.assetCommitments
        );
      };

      ctrl.saveAssetCommitments = (data) => {
        const idx = data?.index || data?.index === 0 ? data?.index : -1;
        if (idx > -1) {
          ctrl.assetCommitmentSchedules[idx].assetCommitments = data?.assetCommitments || [];
          ctrl.saveAssetCommitmentSchedules();
        }
      };

      ctrl.toggleTab = (idx, tab) => {
        ctrl.activeTab = tab === idx ? undefined : idx;
      };

      ctrl.getAssetCommitmentScheduleTotal = ({ assetCommitments, field }) =>
        assetFinanceService.getAssetCommitmentScheduleTotal({ assetCommitments, field });

      ctrl.getContact = (idContact) => _.find(ctrl.companies, (c) => c.id === idContact);

      /*
       * Save asset commitment schedule
       * --------------------------------------------------------------------------------
       */
      ctrl.saveAssetCommitmentSchedules = $mdUtil.debounce(() => {
        ctrl.onFinished({ assetCommitmentSchedules: ctrl.assetCommitmentSchedules });
      }, 1500);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
